<template>
  <span>
    <div class="row" v-for="choice in caseChoices" :key="choice.rps_case_choice" v-on:click="selectionDone(choice)">
      <div :class="getAlignClass">
        <span v-on:mouseover="mouseOver(choice)" v-on:mouseleave="mouseLeave(choice)">
          <card :class="getClass(choice)" :style="cardStyle(choice)">
            <div class="container">
              <div class="row">
                <div>
                  <div class="d-flex align-items-center">
                    <h6 class="mb-0 me-2 font-weight-normal">
                      <span
                        style="user-select: none; -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none; font-size: 0.95rem;"
                        v-html="choice.choice_text"
                      />
                    </h6>
                    <div v-if="showResults()" class="d-block d-sm-none">
                      <Answers
                        :selectedCaseNumber="selectedCaseNumber"
                        :selectedCaseChoice="choice"
                        :sortPlayerNames="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row d-none d-sm-block" v-if="showResults()">
                <Answers
                  :selectedCaseNumber="selectedCaseNumber"
                  :selectedCaseChoice="choice"
                  :sortPlayerNames="true"
                />
              </div>
            </div>
          </card>
        </span>
      </div>
    </div>
  </span>
</template>

<script>
import Vue from "vue";

import Answers from "@/components/rps/Answers.vue";
import { sendRPSAnswer } from "@/services/APIService";

export default {
  props: ["selectedCaseNumber", "disableClick", "sortByPopularity"],
  components: {
    Answers,
  },
  data: function () {
    return {
      answersHaveBeenShown: false,
      hover: [],
      abc: 1,
      answerSent: 0,
    };
  },
  computed: {
    getAlignClass() {
      const caseChoices = this.caseChoices;

      // If all choices are <= 2 characters,
      // let's center the text in card
      let onlyShortChoices = true;

      for (let i = 0; i < caseChoices.length; i++) {
        if (caseChoices[i].choice_text.length > 2) {
          onlyShortChoices = false;
          break;
        }
      }

      if (!onlyShortChoices) {
        return "col text-left";
      }

      return this.showResults() && !onlyShortChoices ? "col text-left" : "col";
    },
    getRowClass() {
      if (this.showResults()) {
        return "col-md-6";
      } else {
        return "col";
      }
    },
    caseChoices() {
      const rpsCase = this.$store.getters.getRPSCaseByCaseNumber(
        this.selectedCaseNumber
      );
      const rpsCaseChoices =
        this.$store.getters.getRPSCaseChoicesOfRPSCaseInCurrentLocale(
          rpsCase.rpsCase
        );
      const answerNumbers = [];

      if (this.sortByPopularity) {
        for (let i = 0; i < rpsCaseChoices.length; i++) {
          const answers = this.$store.getters.getRPSAnswersForRPSCaseChoice(
            rpsCaseChoices[i].rps_case_choice
          );
          answerNumbers.push(answers.length);
        }
        rpsCaseChoices.sort(
          (a, b) =>
            answerNumbers[rpsCaseChoices.indexOf(b)] -
            answerNumbers[rpsCaseChoices.indexOf(a)]
        );
        return rpsCaseChoices;
      } else {
        // Sort by order number
        return this.$store.getters.getRPSCaseChoicesOfRPSCaseInCurrentLocale(
          rpsCase.rpsCase
        );
      }
    },
    getRPSCases() {
      return this.$store.getters.getRPSCasesInCurrentLocale;
    },
  },
  methods: {
    mouseOver(choice) {
      if (!this.disableClick) {
        Vue.set(this.hover, choice.order_number, true);
      }
    },
    mouseLeave(choice) {
      if (!this.disableClick) {
        Vue.set(this.hover, choice.order_number, false);
      }
    },
    cardStyle(choice) {
      let css =
        "margin-bottom: 6px; border-width: 1px !important; border-radius: 12px;";

      const myAnswer = this.$store.getters.getThisPlayersRPSAnswerForCase(
        this.selectedCaseNumber
      );

      if (
        !this.disableClick &&
        myAnswer &&
        myAnswer.answer === choice.rps_case_choice
      ) {
        css += "border-width: 1px !important; border-color: #D15E02; background: linear-gradient(180deg, rgba(254, 133, 2, 0.04) 0%, rgba(209, 94, 2, 0.04) 100%), #FFF; box-shadow: 0px 2px 0px 0px #FFE4CC;"        
      } else {
        css += "border-width: 2px !important; border-color: #bbbbbb; ";
      }

      if (!this.disableClick) {
        css += "cursor: pointer; ";
      } else {
        css += "cursor: initial; ";
      }

      if (!this.disableClick && this.hover[choice.order_number]) {
        css += "top: -3px; left: -3px;";
      }

      return css;
    },
    getClass(choice) {
      if (!this.disableClick && this.hover[choice.order_number]) {
        return "shadow"
      } else {
        return "";
      }
    },
    getRPSCase() {
      return this.$store.getters.getRPSCaseByCaseNumber(
        this.selectedCaseNumber
      );
    },
    selectionDone(selection) {
      if (this.disableClick) {
        return;
      }
      this.$store.dispatch("log", "Sending rps answer");

      if (Date.now() - this.answerSent < 500) {
        // Prevent double click
        return;
      }

      this.answerSent = Date.now()

      sendRPSAnswer(
        this.$store.state.main.game.id,
        this.$store.state.main.thisPlayerId,
        this.$store.state.main.game.gameCode,
        selection.rps_case,
        selection.rps_case_choice
      ).then((resp) => {
        this.$store.dispatch("updateRPSAnswersIfPolling");
      });
    },
    showResults() {
      if (this.answersHaveBeenShown) {
        return true;
      }

      if (
        this.$store.getters.getThisPlayer &&
        this.$store.getters.getThisPlayer.paused &&
        !this.$store.getters.hasThisPlayerDoneRPSAnswerForCase(
          this.selectedCaseNumber
        )
      ) {
        // Paused player has to answer
        return false;
      }

      if (
        this.$store.getters.haveAllPlayersDoneRPSAnswer(this.selectedCaseNumber)
      ) {
        this.answersHaveBeenShown = true;
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .card-body {
  padding: 6px;
}
</style>
